import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Inicio', to: '/' },

  { label: 'Servicios', to: '/servicios' },

  {
    label: 'HSE con Inteligencia',
    to: '/hse-con-inteligencia',
    featured: true
  },

  {
    label: 'Safeline Ai Hub',
    to: '/safeline-ai-hub',
    featured: true
  },

  { label: 'Gestión Documental', to: '/gestion-documental' },

  { label: 'Auditorías HSE', to: '/auditorias' },

  { label: 'Asesoría en Terreno', to: '/asesoria-terreno' },

  { label: 'Sistemas de Gestión (ISO)', to: '/sistemas-gestion' },

  { label: 'Capacitación', to: '/capacitacion' },
];

export default function Navbar({ isScrolled }: { isScrolled: boolean }) {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const location = useLocation();

  const isActive = (to: string) => location.pathname === to;

  return (
    <>

      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || mobileMenuOpen
            ? 'bg-white shadow-lg'
            : 'bg-transparent'
        }`}
      >

        <div className="max-w-7xl mx-auto px-6">

          <div className="flex items-center justify-between h-20">

            {/* LOGO */}
            <Link
              to="/"
              className="flex items-center gap-3 flex-shrink-0"
            >

              <img
                src={
                  isScrolled || mobileMenuOpen
                    ? '/images/logo-dark.svg'
                    : '/images/logo-white.svg'
                }
                alt="SafeLine Solutions"
                width={140}
                height={48}
                decoding="async"
                fetchPriority="high"
                className="h-12 w-auto object-contain transition-all duration-300"
              />

            </Link>

            {/* DESKTOP MENU */}
            <div className="hidden lg:flex items-center gap-4">

              {navItems.map((item) => (

                <Link
                  key={item.to}
                  to={item.to}
                  className={`text-sm font-medium transition-all duration-300 whitespace-nowrap px-3 py-2 rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500 ${
                    item.featured
                      ? 'bg-teal-500/10 text-teal-600 border border-teal-500/20 hover:bg-teal-500/20 hover:scale-105'
                      : isActive(item.to)
                        ? 'text-teal-600 font-semibold'
                        : isScrolled
                          ? 'text-gray-700 hover:text-teal-600'
                          : 'text-white/90 hover:text-white'
                  }`}
                >
                  {item.label}
                </Link>

              ))}

              {/* CONTACT BUTTON */}
              <Link
                to="/contacto"
                className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
              >
                Contacto
              </Link>

            </div>

            {/* MOBILE BUTTON */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`lg:hidden flex flex-col justify-center items-center w-10 h-10 gap-1.5 cursor-pointer rounded-md transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500 ${
                isScrolled || mobileMenuOpen
                  ? 'hover:bg-gray-100'
                  : 'hover:bg-white/10'
              }`}
              aria-label="Abrir menú"
            >

              <span
                className={`block w-6 h-0.5 transition-all duration-300 ${
                  mobileMenuOpen
                    ? 'rotate-45 translate-y-2 bg-gray-800'
                    : isScrolled
                      ? 'bg-gray-700'
                      : 'bg-white'
                }`}
              ></span>

              <span
                className={`block w-6 h-0.5 transition-all duration-300 ${
                  mobileMenuOpen
                    ? 'opacity-0 bg-gray-800'
                    : isScrolled
                      ? 'bg-gray-700'
                      : 'bg-white'
                }`}
              ></span>

              <span
                className={`block w-6 h-0.5 transition-all duration-300 ${
                  mobileMenuOpen
                    ? '-rotate-45 -translate-y-2 bg-gray-800'
                    : isScrolled
                      ? 'bg-gray-700'
                      : 'bg-white'
                }`}
              ></span>

            </button>

          </div>

        </div>

        {/* MOBILE MENU */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            mobileMenuOpen
              ? 'max-h-screen opacity-100'
              : 'max-h-0 opacity-0'
          }`}
        >

          <div className="bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-1">

            {navItems.map((item) => (

              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-left text-sm font-medium px-4 py-3 rounded-lg transition-all duration-300 whitespace-nowrap ${
                  item.featured
                    ? 'bg-teal-500/10 text-teal-700 border border-teal-500/20'
                    : isActive(item.to)
                      ? 'text-teal-600 font-semibold bg-teal-50'
                      : 'text-gray-700 hover:text-teal-600 hover:bg-teal-50'
                }`}
              >
                {item.label}
              </Link>

            ))}

            {/* MOBILE CONTACT BUTTON */}
            <Link
              to="/contacto"
              onClick={() => setMobileMenuOpen(false)}
              className="mt-2 bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap text-center"
            >
              Contacto
            </Link>

          </div>

        </div>

      </nav>

      {/* OVERLAY */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

    </>
  );
}